// import { navigate } from "wouter/use-browser-location";
import {
  jsonDelete,
  jsonGet,
  jsonPost,
  jsonPut,
  prefix,
  uiLanguageHeaders,
  // getProfile,
} from "../api";
// import { useStore } from "../../store"; // HACK!

// AUTH
export async function requestPasswordReset(dto) {
  return await jsonPost("auth/account/forgot-password", dto);
}

export async function changePassword(dto) {
  return await jsonPost("auth/account/change-password", dto);
}

export async function setPassword(dto) {
  return await jsonPut("auth/account/password", dto);
}

// Signed-out reset with the token from the mail ({ token, newPassword }). Uses the token-only
// endpoint: PUT auth/account/password takes the "change my password" branch when an old
// AuthToken cookie is still in the browser (logout does not clear it) and then fails with 403.
// This endpoint also makes the link single-use and ends the user's other sessions.
export async function resetPasswordWithToken(dto) {
  return await sendAuthForm("POST", "auth/account/reset-password", dto);
}

// Request for the signup / activation / reset forms. Unlike jsonPost it shows no global error toast:
// these forms show their own, translated message. The thrown Error carries `status` and the
// server's text (ProblemDetails `detail`, or `{ message }`) as `detail`.
async function sendAuthForm(method, uri, dto) {
  const response = await fetch(`${prefix}/${uri}`, {
    method,
    headers: {
      "content-type": "application/json",
      accept: "application/json",
      ...uiLanguageHeaders(),
    },
    body: dto === undefined ? undefined : JSON.stringify(dto),
  });

  const raw = await response.text();
  let body = null;
  try {
    body = raw ? JSON.parse(raw) : null;
  } catch {
    /* plain-text body */
  }

  if (!response.ok) {
    const detail = body?.detail || body?.message || body?.title || raw || response.statusText;
    const error = new Error(`${response.status}: ${detail}`);
    error.status = response.status;
    error.detail = detail;
    error.code = body?.code ?? null;
    throw error;
  }
  return body ?? {};
}

export async function userRegister(dto) {
  return await sendAuthForm("POST", "auth/account/register", dto);
}

export async function deleteUserSession(sessionId) {
  return await jsonDelete(`auth/account/sessions/${sessionId}`);
}

export async function login(dto) {
  var response = await fetch(`${prefix}/auth/login`, {
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(dto),
  });

  if (!response.ok) {
    // Surface a machine-readable code when the server sends one (e.g. "passkey_required" when the
    // tenant mandates passkey sign-in) so the login form can steer the user instead of showing a
    // generic "incorrect password".
    let code = null;
    try {
      code = (await response.json())?.code ?? null;
    } catch {
      /* non-JSON error body */
    }
    const message = `A login error has occured: ${response.status}`;
    const error = new Error(message, { cause: response.status });
    error.code = code;
    throw error;
  }

  var data = await response.json();
  return data;
}

export async function loginWithToken(token) {
  return await jsonPost("auth/token", { token });
}

export async function userConfirmation(dto) {
  return await sendAuthForm("POST", "auth/account/confirmation", dto);
}

// 404 = unknown invitation, 410 = expired or already accepted (error.code says which).
export const fetchInvite = async (token) =>
  await sendAuthForm("GET", `invitations/${encodeURIComponent(token)}`);

// export const fetchKeys = async () => await jsonGet("auth/passkey/keys");

export const registerKey = async () =>
  await jsonPost("auth/passkey/register/begin");
export const completeKeyRegistration = async (dto) =>
  await jsonPost("auth/passkey/register/complete", dto);
